export default Object.freeze({
  CYSEC: "CYSEC",
  FSA: "FSA",
});
